<!--
  @Description 员工档案
  @Date 2023-08-04
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader title="用户设置"></homeHeader>
    <div class="main">
      <div class="card">
        <div class="toolbar-dv">
          <toolBarBtn
            :parentData="this"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <div class="table-dv">
          <vxe-grid
            border
            resizable
            keep-source
            size="mini"
            :column-config="{ minWidth: '80px' }"
            :edit-rules="validRules"
            :cell-class-name="cellClassName"
            :columns="tableColumns"
            :height="tableHeight"
            ref="xTable"
            :mouse-config="{ area: true, extension: true }"
            :edit-config="{
              trigger: 'dblclick',
              mode: 'cell',
              activeMethod: activeMethod,
              showIcon: false
            }"
            highlight-hover-row
            highlight-current-row
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              enterToTab: true,
              isClip: true,
              isEdit: true,
              editMethod: editMethod
            }"
            :data="tableData"
            :menu-config="{
              body: { options: bodyMenus },
              visibleMethod: visibleMethod
            }"
            @menu-click="contextMenuClickEvent"
            @cell-menu="cellContextMenuEvent"
          ></vxe-grid>
        </div>
      </div>
    </div>

    <vxe-modal
      ref="modal"
      size="mini"
      v-model="selectAuthority.visible"
      title="选择权限"
      width="250px"
      @show="ahorityModalShow"
    >
      <div class="modalSelect">
        <el-select size="mini" v-model="selectAuthority.val" multiple placeholder="请选择">
          <el-option v-for="item in selectAuthority.options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="modalBtn">
        <el-button
          size="mini"
          @click="
            () => {
              selectAuthority.visible = false
            }
          "
          >取消</el-button
        >
        <el-button type="primary" size="mini" @click="confirmAuthority">确定</el-button>
      </div>
    </vxe-modal>

    <!-- 选择文件夹 -->
    <input type="file" ref="uploadFileInput" v-show="false" accept=".png" id="open" @change="uploadFile" />
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
export default {
  components: {},
  created() {},
  activated() {},
  mounted() {
    this.initRightForEdit()
    this.BindData()
    this.BindComBox()
  },
  data() {
    return {
      tableData: [],
      buttonVisible: {
        save: true,
        add: true,
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        update: false,
        delete: false,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      validRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        dept_name: [{ required: true, message: '请选择角色', trigger: 'change' }],
        authority: []
      },
      bodyMenus: [[]],
      // 拓展按钮
      moreButtonList: [],
      // check全选查找值
      checkBoxAll: false,
      //右键缓存
      areas: [],
      // 当前选中列
      colProperty: '',
      selectVisiblePositionArr: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 是否修改
      IfExistModify: false,
      // 校验
      errIndex: [],
      // 选择权限模态窗
      selectAuthority: {
        visible: false,
        val: [],
        options: []
      },
      // 缓存上传的rowid
      cacheRowId: ''
    }
  },
  methods: {
    // 预览签名
    handlePreviewSign(row) {
      this.$hevueImgPreview(row.signature)
    },
    // 展示modal
    ahorityModalShow() {},
    // 模态窗确认
    confirmAuthority() {
      // 赋值权限
      const val = this.selectAuthority.val.join(',')

      this.areas.forEach(a => {
        for (let row of a.rows) {
          for (let column of a.cols) {
            if (column.property === 'authority') {
              row[column.property] = val
            }
          }
        }
      })

      // 关闭窗口
      this.selectAuthority.visible = false
    },
    // 根据权限，初始化控件是否显示
    initRightForEdit() {
      this.buttonVisible.save = this.isCanEdit
      this.buttonVisible.add = this.isCanEdit

      // 有编辑权限才可以显示如下按钮
      if (this.isCanEdit) {
        this.moreButtonList = [
          {
            name: '重置密码',
            icon: 'el-icon-key',
            event: 'handleResetPassword'
          }
        ]
      }
    },
    // 获取数据
    async BindData() {
      this.tableData = []
      const { data: res } = await this.$http.get('/finance/users')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.map(item => {
        item.isCheck = false
        return item
      })
    },
    // 刷新数据
    refresh() {
      this.BindData()
    },
    // 绑定下拉框
    async BindComBox() {
      this.bodyMenus = [
        [
          {
            code: 'role',
            name: '员工',
            value: '员工'
          },
          {
            code: 'role',
            name: '财务',
            value: '财务'
          },
          {
            code: 'role',
            name: '领导',
            value: '领导'
          },
          { code: 'dept_name', name: '软件', value: '软件' },
          { code: 'dept_name', name: '质检', value: '质检' }
        ]
      ]

      this.selectAuthority.options = [
        {
          label: '管理员',
          value: '管理员'
        },
        {
          label: '财务审核',
          value: '财务审核'
        },
        {
          label: '领导审核',
          value: '领导审核'
        },
        {
          label: '总经理审核',
          value: '总经理审核'
        }
      ]
    },
    // 重置密码
    async handleResetPassword() {
      const selectRecords = this.getCheckRecords(this.tableData)
      const idList = this.getIDList(selectRecords)

      if (selectRecords.length === 0) {
        this.$message.warning('请选择需要重置密码的人员!')
        return
      }

      const { data: res } = await this.$http.post(`/finance/users/reset-pwd`, idList)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.clearAllCheck(this.tableData)
    },
    // 获取已勾选的数据
    getCheckRecords(arr) {
      return arr.filter(row => row.isCheck)
    },
    // 清除勾选状态
    clearAllCheck(arr) {
      // 数据行的复选框
      arr.forEach(row => {
        row.isCheck = false
      })
      // 表头的复选框
      this.checkBoxAll = false
    },
    // 保存所拉选的行ID
    getIDList(arr) {
      let res = []
      // 将行id保存
      arr.forEach(row => {
        res.push(row.id)
      })
      return res
    },
    cellContextMenuEvent({ column, row }) {
      this.areas = this.$refs.xTable.getCellAreas()

      if (column.property === 'authority') {
        if (row[column.property]) {
          this.selectAuthority.val = row[column.property].split(',')
        } else {
          this.selectAuthority.val = []
        }

        this.selectAuthority.visible = true
      }
    },
    // 右键打开菜单
    contextMenuClickEvent({ menu }) {
      const areas = this.$refs.xTable.getCellAreas()
      areas.forEach(a => {
        for (let row of a.rows) {
          for (let column of a.cols) {
            if (column.property === menu.code) {
              row[column.property] = menu.name
            }
          }
        }
      })
    },
    // 快捷键
    visibleMethod({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          if (!column || !this.isCanEdit) {
            item.visible = false
          } else {
            item.visible = item.code === column.property
          }
        })
      })
      return true
    },
    // 全选
    checkBoxChangeAll() {
      const tableData = this.$refs.xTable.getTableData().fullData
      for (let item of tableData) {
        item.isCheck = this.checkBoxAll
      }
    },
    add() {
      this.$refs.xTable.insertAt({ id: 0, isCheck: false, name: '', role: '', authority: '' }, 0)
    },
    save() {
      const that = this
      // 保存dgv数据
      that.validEnter().then(async result => {
        if (result) {
          // let insertRecords = that.$refs.xTable.getInsertRecords()
          let removeRecords = that.$refs.xTable.getRemoveRecords()
          // let updateRecords = that.$refs.xTable.getUpdateRecords()
          // that.form.setName = that.setName
          // let form = { ...that.form }
          let detailList = this.$refs.xTable.getTableData().fullData
          // for (let item of insertRecords) {
          //   item.id = 0
          //   detailList.push(item)
          // }
          for (let item of removeRecords) {
            item.id = item.id > 0 ? 0 - item.id : item.id
            detailList.push(item)
          }
          // for (let item of updateRecords) {
          //   detailList.push(item)
          // }
          detailList = that.removeArrayNull(detailList)
          if (detailList.length === 0) {
            that.$XModal.alert({
              message: that.messageConfig.emptyDataForSave,
              status: 'error'
            })
            return
          }

          // 保存节点信息
          const { data: res } = await that.$http.post('/finance/users', detailList)
          if (res.isSuccess) {
            that.BindData()
            that.$message.success('保存成功!')
            that.IfExistModify = false
          } else {
            that.$message.error(res.errorMessage)
          }
        }
      })
    },
    // 验证
    async validEnter() {
      let flag = true
      this.errIndex = []
      this.removeEmptyForTable(this.$refs.xTable)

      // 判断重复数据（用户名）
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['name'])
      if (this.errIndex.length > 0) {
        flag = false
      }

      const errMap = await this.$refs.xTable.fullValidate().catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
      }
      if (this.errIndex.length > 0) {
        flag = false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 删除行
    handleCellDelete(row) {
      if (row.num === 'admin') {
        this.$message.error('管理员不可删除')
        return
      }
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.xTable.remove(row)
          this.IfExistModify = true
        })
        .catch(() => {})
    },
    // cell激活控制
    activeMethod({ column }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!this.isCanEdit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!this.isCanEdit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 导入
    import() {
      this.$refs.Import.isShow = !this.$refs.Import.isShow
    },
    // 返回导入值 | 明细主信息
    async sureImportBack(selectRecords) {
      if (selectRecords.length > 0) {
        this.$refs.xTable.insertAt(selectRecords, -1)
      }
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // 上传电子签名
    handleUploadSign(row) {
      this.cacheRowId = row._XID

      this.$refs.uploadFileInput.click()
    },
    // 删除电子签名
    handleRemoveSign(row) {
      MessageBox.confirm('确认操作吗?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.signature = ''
      })
    },
    // 上传事件
    async uploadFile(event) {
      const input = event.target

      if (input.files && input.files[0]) {
        const file = input.files[0]
        const base64 = await this.getBase64(file)

        // 遍历表格数据，找到对应的行
        const tableData = this.$refs.xTable.getTableData().fullData
        for (const item of tableData) {
          if (item._XID === this.cacheRowId) {
            item.signature = base64
            break
          }
        }
      }

      // 清空历史
      event.target.value = ''
    },
    // 异步获取图片的base64
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function() {
          resolve(reader.result)
        }
        reader.onerror = function(error) {
          reject(error)
        }
      })
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin 否则只有表格的两段 margin
      let topBottomMargin = 20
      let tableMargin = isSearchForm
        ? this.heightConfig.mainMargin * 4
        : this.heightConfig.mainMargin * 2 + topBottomMargin
      let isToolBar = true
      return this.tableHeightComputed(tableMargin, isSearchForm, isToolBar)
    },
    // 单位名称列表
    userCompanyList() {
      let res = []
      this.bodyMenus[0].forEach(item => {
        if (item.code === 'userCompany') {
          res.push(item.value)
        }
      })
      return res
    },
    // 可编辑条件：岗位为 [管理]
    isCanEdit() {
      return true
    },
    // 表格列
    tableColumns() {
      return [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          field: 'delete',
          title: '删除',
          width: '50',
          visible: this.isCanEdit,
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.handleCellDelete(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          width: '50px',
          visible: this.isCanEdit,
          slots: {
            default: ({ row }) => {
              return [<vxe-checkbox v-model={row.isCheck}></vxe-checkbox>]
            },
            header: () => {
              return [
                <vxe-checkbox
                  v-model={this.checkBoxAll}
                  onChange={() => {
                    this.checkBoxChangeAll()
                  }}
                />
              ]
            }
          }
        },
        {
          field: 'name',
          title: '姓名',
          editRender: { name: 'input' },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        },
        {
          field: 'role',
          title: '角色',
          editRender: { name: '$input', attrs: { disabled: true } },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'authority',
          title: '权限',
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'dept_name',
          title: '部门',
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          width: '140px',
          field: 'signBase64',
          title: '电子签名',
          slots: {
            default: ({ row }) => {
              const domList = [
                <el-link
                  type='primary'
                  onClick={() => {
                    this.handleUploadSign(row)
                  }}
                >
                  上传
                </el-link>
              ]

              if (row.signature) {
                domList.unshift(<span style='margin-left: 5px'></span>)

                domList.unshift(
                  <el-link
                    type='primary'
                    onClick={() => {
                      this.handlePreviewSign(row)
                    }}
                  >
                    预览
                  </el-link>
                )

                domList.push(<span style='margin-left: 5px'></span>)

                domList.push(
                  <el-link
                    type='danger'
                    onClick={() => {
                      this.handleRemoveSign(row)
                    }}
                  >
                    清空
                  </el-link>
                )
              }

              return domList
            }
          }
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.vxe-checkbox {
  width: 15px !important;
}

.modalSelect {
  width: 100%;
  margin-bottom: 10px;
}

.modalBtn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.el-link {
  font-size: 12px;
}
</style>
